import Logo from 'components/common/Logo';
import AppContext from 'context/Context';
import { useContext } from 'react';
import { Button } from 'react-bootstrap';

const ToggleButtonWithLogo = () => {
  const {
    config: { isNavbarVerticalCollapsed },
    setConfig
  } = useContext(AppContext);

  const handleClick = () => {
    document
      .getElementsByTagName('html')[0]
      .classList.toggle('navbar-vertical-collapsed');
    setConfig('isNavbarVerticalCollapsed', !isNavbarVerticalCollapsed);
  };

  return (
    <div
      className="toggle-icon-wrapper m-0 d-flex align-items-center"
      style={{ minWidth: 250, width: 250 }}
    >
      <Button
        variant="link"
        className="navbar-toggler-humburger-icon navbar-vertical-toggle ms-1"
        id="toggleNavigationTooltip"
        onClick={handleClick}
        style={{ aspectRatio: '1/1' }}
      >
        <span className="navbar-toggle-icon">
          <span className="toggle-line" />
        </span>
      </Button>
      <Logo at="navbar-vertical" />
    </div>
  );
};

export default ToggleButtonWithLogo;
